import { cn } from "cn"
import { Icon } from "@iconify/react"

function Spinner({
  className,
  ...props
}: Omit<React.ComponentProps<typeof Icon>, "icon">) {
  return (
    <Icon
      icon="lucide:loader-2"
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      aria-hidden={false}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
